module.exports = __webpack_public_path__ + "static/img/5.ca532cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/sp/5.png
// module id = zGQ4
// module chunks = 0